import React, { useState } from "react";
import { convertJSONtoFormData } from "../../helper/_commonHelper";
import Modal from "react-modal";
import { useToast } from "@chakra-ui/toast";
import axios from "axios";
import AddEditTranslations from "../translations/AddEditTranslations";

const AddEditSubAddOn = ({ title, data, ids, open, setShow, refresh, showDescriptionField }) => {
  const [formData, setFormData] = useState({
    menu_item_id: ids?.itemId,
    name: data?.name || "",
    description: data?.description || "",
    priority: data?.priority || 0,
    price: data?.price || 0,
    type: data?.type || "single_select",
    max_addon_per_order: data?.max_addon_per_order,
    min_addon_per_order: data?.min_addon_per_order || 0,
    tags: [],
    translations: data?.translations || [],
  });
  const [errors, setError] = useState(null);
  const toast = useToast();
  const [rows, setRows] = useState([]);

  const handleChange = (evt) => {
    let value = null;
    if (evt.target.type === "checkbox") {
      value = evt.target.checked;
    } else if (evt.target.type === "file") {
      value = evt.target.files[0];
    } else {
      value = evt.target.value;
    }
    setFormData({
      ...formData,
      [evt.target.name]: value,
    });
  };

  const saveForm = async () => {
    if (data?.id) {
      delete formData.menu_id;
    }

    try {
      let updatedRows = rows.map((row) => ({
        hotel_language_id: row.hotel_language_id,
        name: row.name,
        description: row.description
      }));
      formData['translations'] = updatedRows;
      const datatoSend = convertJSONtoFormData(formData);
      let response = await axios.post(
        (data?.id
          ? "/outlet/update/menu/category/item/sub-addon"
          : "/outlet/menu/sub-addon") + (data?.id ? "/" + data?.id : ""),
        datatoSend
      );

      if (response.status === 201) {
        const result = response.data || {};
        showToast("Sub Addon Created!", result?.message);
        setShow(false);
        refresh();
      } else if (response.status === 202) {
        const result = response.data || {};
        showToast("Sub Addon Updated!", result?.message);
        setShow(false);
        refresh();
      } else if (response.status === 400) {
        const result = response.data || {};
        const keys = Object.keys(result?.message);
        let errs = keys?.map((key) => {
          return {
            field: key,
            error: result?.message?.[key]?.[0],
          };
        });
        setError(errs);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const submit = async () => {
    await saveForm();
  };
  const showToast = (title, description) => {
    toast({
      title: title || "Menu Updated!",
      description:
        `${description}!` || "Menu change has been done successfully!!",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };
  return (
    <Modal
      isOpen={open}
      onRequestClose={() => setShow(false)}
      className={"modal-dialog modal-lg modal-order-details"}
      overlayClassName={"modal-backdrop overflow-auto "}
      contentLabel="Example Modal"
    >
      <div className="modal-content" aria-modal="true" id="modal-content-block">
        <div className="modal-header">
          <div className="title">
            {" "}
            {data?.id ? "Edit " + title : "Add " + title}
          </div>

          <button className="btn btn-icon" onClick={() => setShow(false)}>
            <i className="fa fa-times"></i>
          </button>
        </div>
        <div className="modal-body">
          {/* FORM */}
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
          </div>
          {/* <div className="form-group">
              <label htmlFor="exampleInputEmail1">Description</label>
              <input
                type="text"
                className="form-control"
                placeholder="Description"
                name="description"
                value={formData.description}
                onChange={handleChange}
              />
            </div> */}
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">Type</label>
            <select
              className="form-control"
              value={formData.type}
              onChange={(e) => handleChange(e)}
              name="type"
            >
              <option value={"single_select"}>Single Select</option>
              <option value={"multi_select"}>Multi Select</option>
            </select>
          </div>
          {/* {
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Image</label>
                <input
                  type="file"
                  className="form-control"
                  placeholder="image"
                  name="image"
                  // value={formData.image}
                  onChange={handleChange}
                />
              </div>
            } */}
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">Priority</label>
            <input
              type="number"
              className="form-control"
              placeholder="priority"
              name="priority"
              value={formData.priority}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">
              Maximum options that a guest can choose.
            </label>
            <input
              type="number"
              className="form-control"
              placeholder="Choose a number greater than 0"
              name="max_addon_per_order"
              value={formData.max_addon_per_order}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">min per order</label>
            <input
              type="number"
              className="form-control"
              placeholder="min_addon_per_order"
              name="min_addon_per_order"
              value={formData.min_addon_per_order}
              onChange={handleChange}
            />
          </div>

          <div className='form-group'>
            <label htmlFor='xampleInputEmail1'>Translations</label>
            <AddEditTranslations
              translations={formData.translations}
              rows={rows}
              setRows={setRows}
              showDescriptionField={showDescriptionField}
            />
          </div>
          <div className="text-danger">
            {errors &&
              errors.map((err) => (
                <>
                  <div>
                    {err?.field?.toUpperCase()} : {err?.error}
                  </div>
                </>
              ))}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn" onClick={() => setShow(false)}>
            Close
          </button>
          <button className="btn btn-primary" onClick={() => submit()}>
            Save changes
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AddEditSubAddOn;
